import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from "../../lib";

import { doREQUEST_ERROR, doREQUEST_COMPLETE, doDIGEST_DAY_SET } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_PARTICIPANT_DAILY_DATA_DIGEST = "REQUEST_PARTICIPANT_DAILY_DATA_DIGEST";
export const doREQUEST_REQUEST_PARTICIPANT_DAILY_DATA_DIGEST = createDoRequestAction(
  REQUEST_PARTICIPANT_DAILY_DATA_DIGEST,
);

export const requestParticipantDailyDataDigestActionCreators = {
  doREQUEST_REQUEST_PARTICIPANT_DAILY_DATA_DIGEST,
};

export function* requestParticipantDailyDataDigest({
  payload,
  setRequestResult,
}: any): SagaIterator {
  debug("saga*requestParticipantDailyDataDigest");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid(),
        projectId: v.string().uuid().exist(),
        participantId: v.string().uuid().exist(),
        yymmddIndex: v.number(),
        requestGarminDirectData: v.bool(),
        requestGarminConnectData: v.bool(),
        requestDexcomData: v.bool(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_DAILY_DATA_DIGEST,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const {
    participantId,
    yymmddIndex,
    requestGarminDirectData,
    requestGarminConnectData,
    requestDexcomData,
  } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v2/web/participant-daily-data-digest`,
    accessToken,
    data: {
      participantId,
      yymmddIndex,
      requestGarminDirectData,
      requestGarminConnectData,
      requestDexcomData,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_DAILY_DATA_DIGEST,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v2/web/participant-daily-data-digest",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  // console.log('participant-daily-data-digest', result.payload)
  yield put(
    doDIGEST_DAY_SET({
      ...result.payload,
    }),
  );

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PARTICIPANT_DAILY_DATA_DIGEST,
        fromPayload: payload,
        requestId: payload.requestId,
        url: "/v2/web/participant-daily-data-digest",
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* participantDailyDataDigestSaga() {
  yield takeEvery(REQUEST_PARTICIPANT_DAILY_DATA_DIGEST, requestParticipantDailyDataDigest);
}
